import { utility } from 'rutter'

export type URLBuilderOptions = utility.URLBuilderOptions
export const buildURL = utility.buildURL

export const clipboardCopyText = (value: string) =>
  navigator.clipboard.writeText(value)
